var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"qrcode",staticClass:"qr"}),_c('div',{staticStyle:{"width":"100%","border":"solid 1px","font-size":"80pt"}},[_vm._v("Clicks: "+_vm._s(_vm.clicks || 0))])])
}
var staticRenderFns = []

export { render, staticRenderFns }